import { useEffect, useState } from "react";
import { IComment, ITransaction } from "../../interface/ITransactionHistory";
import { getPaymentDetailsRoute } from "@api-routes";
import { useFetch } from "@common/hook/useFetch";
import { format, subMonths } from "date-fns";
import { API_DATE_FORMAT } from "@constants";
import { getLanguage } from "@utils/changeLanguage";

export const useGetPaymentDetails = (
    paymentCorrelationTransactionUuid: ITransaction["paymentCorrelationTransactionUuid"],
    month: number
) => {
    const [paymentDetails, setPaymentDetails] = useState<IComment>();
    const [getPaymentDetailsState, { get }] = useFetch();
    const lang = getLanguage();
    const now = new Date();
    const to = format(now, API_DATE_FORMAT);
    const from = format(subMonths(now, month), API_DATE_FORMAT);
    const params = `?lang=${lang}&from=${from}&to=${to}`;

    useEffect(() => {
        get<IComment>(getPaymentDetailsRoute(paymentCorrelationTransactionUuid, params)).then(setPaymentDetails);
    }, [paymentCorrelationTransactionUuid]);

    return { paymentDetails, getPaymentDetailsState };
};
